import { Typography, Button, Grid } from '@material-ui/core'
import React from 'react'
import { useHistory } from 'react-router'

export const NotFoundPage = () => {
  const history = useHistory()
  return (
    <Grid container direction="column">
      <Typography variant="h5" color="textPrimary" gutterBottom>
        Opps. We could not find this page.
      </Typography>
      <Button variant="contained" color="primary" onClick={() => history.push('/')}>
        Go back home
      </Button>
    </Grid>
  )
}
